import { render, staticRenderFns } from "./PlanCompany.vue?vue&type=template&id=a856f23e&scoped=true&"
import script from "./PlanCompany.vue?vue&type=script&lang=js&"
export * from "./PlanCompany.vue?vue&type=script&lang=js&"
import style0 from "./PlanCompany.vue?vue&type=style&index=0&id=a856f23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a856f23e",
  null
  
)

export default component.exports